import type React from 'react';

interface RoundedCardProps {
  showShadow?: boolean;
  children: React.ReactNode;
  onClick?: () => void;
}

const RoundedCard = ({ children, showShadow = true, onClick }: RoundedCardProps) => {
  const shadowClass = showShadow
    ? 'shadow-[0_3px_12px_0_rgba(0,0,0,0.05)] dark:shadow-[0_3px_12px_0_rgba(0,0,0,0.26)] dark:shadow-[0_0_2px_0_rgba(0,0,0,0.25),_0_2px_13.9px_0_rgba(0,0,0,0.55)]'
    : '';
  return (
    <div
      className={`rounded-[24px] border border-[#f4f4f480] bg-pure-white dark:bg-backgroundElevated-dark dark:border-[rgba(26,26,26,0.60)] leading-none ${shadowClass}`}
      onClick={() => onClick?.()}
    >
      {children}
    </div>
  );
};

export default RoundedCard;